import { createFileRoute } from '@tanstack/react-router';

import { faCalculatorSimple } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box, Typography } from '@mui/material';

export const Route = createFileRoute(
	'/_claims/claim/$claimId/_claim/calculations/salesLoss',
)({
	component: function SalesLossCalculationsPage() {
		return (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					p: 4,
					gap: 1,
					border: '1px solid',
					borderColor: 'accent.main',
					width: '600px',
					maxWidth: '100%',
					mx: 'auto',
				}}
			>
				<FontAwesomeIcon icon={faCalculatorSimple} size="2xl" />
				<Typography variant="subtitle1">Sales Loss Calculations</Typography>
				<Typography variant="body2" color="text.secondary">
					Content coming soon
				</Typography>
			</Box>
		);
	},
});
